var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("text-settings")))]),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-input", {
                    attrs: {
                      label: _vm.$ct("default-comment"),
                      fancy: "",
                      icon: "globe-africa",
                    },
                    on: {
                      "icon-click": function ($event) {
                        return _vm.editDefaultCommentTranslations()
                      },
                    },
                    model: {
                      value: _vm.config.DefaultComment.Translations[_vm.locale],
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.config.DefaultComment.Translations,
                          _vm.locale,
                          $$v
                        )
                      },
                      expression: "config.DefaultComment.Translations[locale]",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-input", {
                    attrs: {
                      label: _vm.$ct("subtotal"),
                      fancy: "",
                      icon: "globe-africa",
                    },
                    on: {
                      "icon-click": function ($event) {
                        return _vm.editSubTotalTranslations()
                      },
                    },
                    model: {
                      value: _vm.config.SubTotal.Translations[_vm.locale],
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.config.SubTotal.Translations,
                          _vm.locale,
                          $$v
                        )
                      },
                      expression: "config.SubTotal.Translations[locale]",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-row",
            { attrs: { grow: "" } },
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-input", {
                    attrs: {
                      icon: "globe-africa",
                      editor: "",
                      fancy: "",
                      label: _vm.$ct("requirements"),
                      "force-modal-editor": "",
                    },
                    on: {
                      "icon-click": function ($event) {
                        return _vm.editRequirementTranslations()
                      },
                      focus: function ($event) {
                        return _vm.editRequirementTranslations()
                      },
                    },
                    model: {
                      value: _vm.config.Requirements.Translations[_vm.locale],
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.config.Requirements.Translations,
                          _vm.locale,
                          $$v
                        )
                      },
                      expression: "config.Requirements.Translations[locale]",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.translatedDefaultCommentModal
        ? _c(
            "w-modal",
            {
              model: {
                value: _vm.translatedDefaultCommentModal,
                callback: function ($$v) {
                  _vm.translatedDefaultCommentModal = $$v
                },
                expression: "translatedDefaultCommentModal",
              },
            },
            [
              _c("app-translation-edit-modal", {
                attrs: { title: _vm.$ct("default-comment") },
                on: {
                  close: function ($event) {
                    _vm.translatedDefaultCommentModal = false
                  },
                },
                model: {
                  value: _vm.config.DefaultComment,
                  callback: function ($$v) {
                    _vm.$set(_vm.config, "DefaultComment", $$v)
                  },
                  expression: "config.DefaultComment",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.translatedSubTotalModal
        ? _c(
            "w-modal",
            {
              model: {
                value: _vm.translatedSubTotalModal,
                callback: function ($$v) {
                  _vm.translatedSubTotalModal = $$v
                },
                expression: "translatedSubTotalModal",
              },
            },
            [
              _c("app-translation-edit-modal", {
                attrs: { title: _vm.$ct("subtotal") },
                on: {
                  close: function ($event) {
                    _vm.translatedSubTotalModal = false
                  },
                },
                model: {
                  value: _vm.config.SubTotal,
                  callback: function ($$v) {
                    _vm.$set(_vm.config, "SubTotal", $$v)
                  },
                  expression: "config.SubTotal",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.translateRequirementsModal
        ? _c(
            "w-modal",
            {
              model: {
                value: _vm.translateRequirementsModal,
                callback: function ($$v) {
                  _vm.translateRequirementsModal = $$v
                },
                expression: "translateRequirementsModal",
              },
            },
            [
              _c("app-translation-edit-modal", {
                attrs: { title: _vm.$ct("requirements"), textarea: "" },
                on: {
                  close: function ($event) {
                    _vm.translateRequirementsModal = false
                  },
                },
                model: {
                  value: _vm.config.Requirements,
                  callback: function ($$v) {
                    _vm.$set(_vm.config, "Requirements", $$v)
                  },
                  expression: "config.Requirements",
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }